import { z } from '@hono/zod-openapi'
import { benefitSubCategoriesTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export const zSelectBenefitSubCategories = createSelectSchema(
    benefitSubCategoriesTable,
)

export const zInsertBenefitSubCategories = createInsertSchema(
    benefitSubCategoriesTable,
).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})

export const zUpdateBenefitSubCategories = zInsertBenefitSubCategories.partial()

export const zQueryBenefitSubCategories = zInsertBenefitSubCategories
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()

export type SelectBenefitSubCategories = z.infer<
    typeof zSelectBenefitSubCategories
>
export type InsertBenefitSubCategories = z.infer<
    typeof zInsertBenefitSubCategories
>
export type UpdateBenefitSubCategories = z.infer<
    typeof zUpdateBenefitSubCategories
>
export type QueryBenefitSubCategories = z.infer<
    typeof zQueryBenefitSubCategories
>
export type ColumnsOfBenefitSubCategoriesTable =
    keyof typeof benefitSubCategoriesTable._.columns
